/* eslint no-new:0 */
import React from 'react';
import { CompositeDecorator } from 'draft-js';
import { INLINE_REFERENCE_TYPE } from '../utilities/CONSTANTS';
import { RESOURCE_TYPE } from '../../utilities/CONSTANTS';
// Strategies
import findLinkEntities from '../strategies/findLinkEntities';
import findLinkText from '../strategies/findLinkText';
import mentionEntityStrategy from '../strategies/mentionEntityStrategy';
import pageReferenceEntityStrategy from '../strategies/pageReferenceEntityStrategy';
import githubIssueEntityStrategy from '../strategies/githubIssueEntityStrategy';
import { createInlineReferenceEntityStrategy, createInlineReferencesEntityStrategy } from '../strategies/inlineReferenceEntityStrategy';
import googleDriveDocEntityStrategy from '../strategies/googleDriveDocEntityStrategy';
// Components
import Link from '../components/Link';
import TextLink from '../components/TextLink';
import PageReference from '../components/inline-references/PageReference';
import ResourceInlineReference from '../components/inline-references/ResourceInlineReference';
import GithubIssueReference from '../components/inline-references/GithubIssueReference';
import GoogleDriveReference from '../components/inline-references/GoogleDriveReference';
import UserReference from '../components/inline-references/Mention';
import LegacyMention from '../components/inline-references/legacy/Mention';
import LegacyPageReference from '../components/inline-references/legacy/PageReference';
import LegacyGithubIssue from '../components/inline-references/legacy/GithubIssue';
import LegacyGoogleDriveDoc from '../components/inline-references/legacy/GoogleDriveDoc';

const compositeDecorator = (
    readOnly,
) => {
    const entityDecorators = [
        {
            strategy: findLinkEntities,
            component: props => <Link {...props} readOnly={readOnly} />,
        },
        {
            strategy: findLinkText,
            component: TextLink,
        },
        {
            strategy: createInlineReferenceEntityStrategy(INLINE_REFERENCE_TYPE.GITHUB_ISSUE),
            component: props => <GithubIssueReference {...props} readOnly={readOnly} />,
        },
        {
            strategy: createInlineReferenceEntityStrategy(INLINE_REFERENCE_TYPE.PAGE_REFERENCE),
            component: props => <PageReference {...props} readOnly={readOnly} />,
        },
        {
            strategy: createInlineReferenceEntityStrategy(INLINE_REFERENCE_TYPE.GOOGLE_DOC),
            component: props => <GoogleDriveReference {...props} readOnly={readOnly} />,
        },
        {
            strategy: createInlineReferenceEntityStrategy(INLINE_REFERENCE_TYPE.MENTION),
            component: props => <UserReference {...props} readOnly={readOnly} />,
        },
        {
            strategy: createInlineReferencesEntityStrategy([
                RESOURCE_TYPE.TETTRA_QUESTION,
                RESOURCE_TYPE.NOTION_PAGE,
            ]),
            component: props => <ResourceInlineReference {...props} readOnly={readOnly} />,
        },
    ];

    // TODO Once all legacy inline references have been migrated these should be deprecated
    // These are currently being converted via a just-in-time converter whenever a draft of a page is opened.
    const legacyInlineReferenceDecorators = [
        {
            strategy: pageReferenceEntityStrategy,
            component: LegacyPageReference,
        },
        {
            strategy: mentionEntityStrategy,
            component: LegacyMention,
        },
        {
            strategy: githubIssueEntityStrategy,
            component: props => <LegacyGithubIssue {...props} readOnly={readOnly} />,
        },
        {
            strategy: googleDriveDocEntityStrategy,
            component: LegacyGoogleDriveDoc,
        },
    ];

    return new CompositeDecorator(entityDecorators.concat(legacyInlineReferenceDecorators));
};

export default compositeDecorator;
